var modules_997b7aad = {"logoLink":"_miq89w","logo":"_1ggywrw"};
import "../../../assets/JaavXYJq.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
